import { jobs } from './jobs';

export const common = {
  nav: {
    home: 'Accueil',
    jobs: 'Offres d\'emploi',
    candidates: 'Candidats',
    employers: 'Employeurs',
    international: 'Recrutement International',
    login: 'Connexion',
    register: 'S\'inscrire',
  },
  hero: {
    title1: 'Trouvez votre',
    title2: 'prochain défi',
    title3: 'professionnel',
    subtitle: 'Connectez-vous avec les meilleures opportunités de carrière et les talents les plus qualifiés',
    searchPlaceholder: 'Poste, mot-clé, entreprise...',
    locationPlaceholder: 'Ville, région...',
    contractType: 'Type de contrat',
    searchButton: 'Rechercher',
    uploadCV: 'Déposer mon CV',
    hireTalent: 'Recruter des talents'
  },
  metrics: {
    jobs: 'Offres d\'emploi actives',
    placements: 'Candidats placés',
    companies: 'Entreprises partenaires'
  },
  jobs: {
    title: 'Dernières opportunités',
    viewOffer: 'Voir l\'offre',
    cdi: 'CDI',
    cdd: 'CDD',
    stage: 'Stage',
    freelance: 'Freelance',
    all: 'Tous'
  },
  testimonials: {
    label: 'Témoignage Candidat',
    title1: 'Une expérience de',
    title2: 'recrutement exceptionnelle',
    quote: '« Grâce à Travail Global, j\'ai trouvé le poste idéal en moins de deux semaines. L\'équipe a été à l\'écoute de mes besoins et m\'a accompagné tout au long du processus. Une expérience professionnelle et humaine remarquable. »',
    author: 'Sophie Martin, Responsable Marketing'
  },
  features: {
    title: 'Pourquoi choisir Travail Global',
    description: 'Une plateforme complète qui connecte les talents avec les opportunités, partout dans le monde',
    forCandidates: 'Pour les Candidats',
    candidatesDesc: 'Accédez à des milliers d\'offres, créez votre profil professionnel et recevez des recommandations personnalisées',
    forCompanies: 'Pour les Entreprises',
    companiesDesc: 'Trouvez les meilleurs talents, gérez vos recrutements et développez vos équipes efficacement',
    international: 'Recrutement International',
    internationalDesc: 'Élargissez vos horizons avec notre réseau mondial de talents et d\'opportunités'
  },
  cta: {
    ready: 'Prêt à démarrer ?',
    join1: 'Rejoignez',
    join2: 'notre communauté',
    join3: 'dès aujourd\'hui',
    createAccount: 'Créez votre compte gratuitement',
    ctaDescription: 'Que vous soyez à la recherche de votre prochain défi professionnel ou du talent idéal pour votre entreprise, Travail Global vous accompagne à chaque étape de votre parcours.',
    startNow: 'Commencer maintenant'
  },
  footer: {
    description: 'Votre partenaire de confiance pour le recrutement et le développement de carrière',
    newsletter: 'Restez informé',
    emailPlaceholder: 'Votre adresse email',
    subscribe: 'S\'abonner',
    legal: 'En vous abonnant, vous acceptez notre',
    privacyPolicy: 'politique de confidentialité',
    quickLinks: 'Liens Rapides',
    forCandidates: 'Pour Candidats',
    forEmployers: 'Pour Employeurs',
    resources: 'Ressources',
    blog: 'Blog',
    careerAdvice: 'Conseils Carrière',
    salaryGuide: 'Guide des Salaires',
    copyright: 'Tous droits réservés',
    terms: 'Conditions d\'utilisation',
    privacy: 'Confidentialité',
    cookies: 'Cookies'
  }
};

export { jobs };